export default function Router($stateProvider) {
    "ngInject";

    $stateProvider
        .state({
            name: "users",
            url: "/app/users/:createdCompany",
            template: "<users></users>",
            resolve: {
                $title: () => "Users | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/users/users-router.js